import { h, Fragment } from 'preact';
import { useMemo } from 'preact/hooks';
import getCurrentLocale from './get-current-locale';

const FormatMoney = ({ amount, currencyCode = 'USD', salePrice = false, cartDrawerFooter = false }, cents = false) => {

  // salePrice is referring to the marked down price when the "Compare-at price" is in use
  // cartDrawerFooter is to determine if the price is being used in the cart drawer footer, where the currency code should be visible but not within a <sup> tag

  let amt = amount;
  if (Number.isNaN(amt)) {
    // eslint-disable-next-line no-console
    console.error('utils/format-money.js: No amount value passed.');
    return null;
  }

  if (cents) amt /= 100;

  const formatterOptions = {
    style: 'currency',
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: amt % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  };

  if (currencyCode !== '') {
    formatterOptions.currency = currencyCode;
  }

  const locale = getCurrentLocale() ?? 'en-US';
  const formatter = new Intl.NumberFormat(locale, formatterOptions);
  const parts = formatter.formatToParts(amt);
  let currencySymbol = '';
  let price = '';

  for (const part of parts) {
    if (part.type === 'currency') {
      currencySymbol = part.value;
    } else {
      price += part.value;
    }
  }

  const renderCurrencyCode = useMemo(() => {
    if (currencyCode) {
      if (salePrice) {
        return <sup data-price-element="currency-code" className="-top-[2px] text-xs font-normal">&nbsp;{currencyCode}</sup>;
      }

      if (cartDrawerFooter) {
        return <span data-price-element="currency-code">&nbsp;{currencyCode}</span>;
      }
    }

    return null;
  })

  return (
    <>
      <span>{currencySymbol}{price}</span>
      {renderCurrencyCode}
    </>
  );
};

export default FormatMoney;